import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, signOut, type User } from 'firebase/auth';

/** Ứng dụng dùng riêng một người. Chặn thật sự nằm ở firestore.rules (isAllowedAccount); đây chỉ là báo lỗi sớm cho đỡ khó hiểu. */
export const ALLOWED_EMAIL = 'tdongloc1712@gmail.com';
export const isAllowedUser = (u: Pick<User, 'email' | 'emailVerified'> | null) =>
  !!u && u.emailVerified && (u.email ?? '').toLowerCase() === ALLOWED_EMAIL;

export const useAuthUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => onAuthStateChanged(getAuth(), (u) => {
    if (u && !isAllowedUser(u)) {
      setError(`Tài khoản ${u.email ?? ''} không được phép dùng ứng dụng này.`);
      void signOut(getAuth());
      setUser(null);
    } else setUser(u);
    setLoading(false);
  }), []);

  const signIn = async () => {
    setError(null);
    try {
      const provider = new GoogleAuthProvider();
      // Gợi ý sẵn tài khoản duy nhất được phép để Google bỏ qua bước chọn tài khoản (vẫn phải xác thực với Google).
      provider.setCustomParameters({ login_hint: ALLOWED_EMAIL });
      await signInWithPopup(getAuth(), provider);
    } catch (e) {
      const code = (e as { code?: string }).code;
      setError(code === 'auth/popup-closed-by-user' ? 'Bạn đã đóng cửa sổ đăng nhập.' : `Không đăng nhập được: ${(e as Error).message}`);
    }
  };
  return { user, loading, error, signIn, signOut: () => signOut(getAuth()) };
};
